import { useCallback, useEffect, useState } from "react";

import { ARM_DELAY_MS } from "../constants/payoutBatches.constants";

/**
 * The money-moving dialogs keep their primary button disabled for a moment after opening, long enough for the
 * summary to be read. Call `disarm` when the dialog closes so the next opening waits again.
 */
export function useArmDelay(open: boolean): {
  armed: boolean;
  disarm: () => void;
} {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => setArmed(true), ARM_DELAY_MS);
    return () => clearTimeout(timer);
  }, [open]);

  const disarm = useCallback(() => setArmed(false), []);

  return { armed, disarm };
}
